import React from 'react'

import Svg, { ClipPath, Defs, G, Path, Rect } from 'react-native-svg'

const CurrencyIcon = ({ size = 20, color = '#596379', ...props }) => {
  return (
    <Svg
      width={`${size}px`}
      height={`${size}px`}
      viewBox={`0 0 ${size} ${size}`}
      fill="none"
    >
      <G clipPath="url(#clip0_8531_7079)">
        <G clipPath="url(#clip1_8531_7079)">
          <Path
            d="M17.1085 8.54167C17.3085 8.54167 17.4668 8.7 17.4668 8.9V15.4333C17.4668 15.6333 17.3085 15.7917 17.1085 15.7917H4.6168C4.4168 15.7917 4.25846 15.6333 4.25846 15.4333V8.9C4.25846 8.7 4.4168 8.54167 4.6168 8.54167H17.1001M17.1001 7.375H4.6168C3.77513 7.375 3.0918 8.05833 3.0918 8.9V15.4333C3.0918 16.275 3.77513 16.9583 4.6168 16.9583H17.1001C17.9418 16.9583 18.6251 16.275 18.6251 15.4333V8.9C18.6251 8.05833 17.9418 7.375 17.1001 7.375Z"
            fill="black"
          />
          <Path
            d="M14.8925 9.60833C14.8925 9.54166 14.9008 9.47499 14.9175 9.40833H6.98418C7.00085 9.47499 7.00918 9.54166 7.00918 9.60833C7.00918 10.25 6.36751 10.775 5.58418 10.775C5.52585 10.775 5.46751 10.7667 5.40918 10.7583V13.5667C5.46751 13.5667 5.52585 13.55 5.58418 13.55C6.37585 13.55 7.00918 14.075 7.00918 14.7167C7.00918 14.7833 7.00085 14.85 6.98418 14.9167H14.9175C14.9008 14.85 14.8925 14.7833 14.8925 14.7167C14.8925 14.075 15.5342 13.55 16.3175 13.55V10.7667C15.5258 10.7667 14.8925 10.2417 14.8925 9.59999V9.60833ZM7.81751 12.6833C7.53418 12.6833 7.30085 12.45 7.30085 12.1667C7.30085 11.8833 7.53418 11.65 7.81751 11.65C8.10085 11.65 8.33418 11.8833 8.33418 12.1667C8.33418 12.45 8.10085 12.6833 7.81751 12.6833ZM10.8592 13.5C10.1258 13.5 9.52585 12.9 9.52585 12.1667C9.52585 11.4333 10.1258 10.8333 10.8592 10.8333C11.5925 10.8333 12.1925 11.4333 12.1925 12.1667C12.1925 12.9 11.5925 13.5 10.8592 13.5ZM13.8758 12.7333C13.5925 12.7333 13.3592 12.5 13.3592 12.2167C13.3592 11.9333 13.5925 11.7 13.8758 11.7C14.1592 11.7 14.3925 11.9333 14.3925 12.2167C14.3925 12.5 14.1592 12.7333 13.8758 12.7333Z"
            fill="black"
          />
          <Path
            d="M2.92546 13.2917H2.65046C2.45046 13.2917 2.29212 13.1333 2.29212 12.9333V6.4C2.29212 6.2 2.45046 6.04167 2.65046 6.04167H15.1338C15.3338 6.04167 15.4921 6.2 15.4921 6.4V7.16667H16.6588V6.4C16.6588 5.55833 15.9755 4.875 15.1338 4.875H2.65879C1.81712 4.875 1.13379 5.55833 1.13379 6.4V12.9333C1.13379 13.775 1.81712 14.4583 2.65879 14.4583H2.93379V13.2917H2.92546Z"
            fill="black"
          />
        </G>
      </G>
      <Defs>
        <ClipPath id="clip0_8531_7079">
          <Rect
            width={`${size}`}
            height={`${size}`}
            transform="translate(0 0.5)"
          />
        </ClipPath>
        <ClipPath id="clip1_8531_7079">
          <Rect
            width={`${size}`}
            height={`${size}`}
            transform="translate(0 0.5)"
          />
        </ClipPath>
      </Defs>
    </Svg>
  )
}

export default CurrencyIcon
